import { FavouriteDefinition, Value } from 'app/types-shared';
import { transformSelectedReport } from 'app/area/favourite/favourite-definition-transforms/selected-report';

export const updateDrillDownLayoutType = (definition: FavouriteDefinition, drillDownLayoutType: Value) => 
  transformSelectedReport({
    drillDownLayoutType
  })(definition);
